import {
  UPDATE_EDIT_VALUE,
  UPDATE_LAST_UPDATED,
  UPDATE_LOADING_PART,
  UPDATE_PARTS,
  UPDATE_PART_DATA,
  FETCH_PARTS,
  FETCH_PARTS_START,
  FETCH_PARTS_SUCCESS,
  FETCH_PARTS_ERROR,
  POST_PARTS,
  POST_PARTS_START,
  POST_PARTS_SUCCESS,
  POST_PARTS_ERROR,
} from './constants'
import {
  buildAsyncAction,
} from 'containers/Async/actions'

const updateEditValue = (key, value) => ({ type: UPDATE_EDIT_VALUE, key, value })
const updateLastUpdated = (part, value) => ({ type: UPDATE_LAST_UPDATED, part, value })
const updateLoadingPart = (part, value) => ({ type: UPDATE_LOADING_PART, part, value })
const updateParts = (parts) => ({ type: UPDATE_PARTS, parts })
const updatePartData = (partName, partData) => ({ type: UPDATE_PART_DATA, partName, partData })

const fetchParts = () => ({ type: FETCH_PARTS })
const fetchPartsStart = () => ({ type: FETCH_PARTS_START })
const fetchPartsSuccess = () => ({ type: FETCH_PARTS_SUCCESS })
const fetchPartsError = (error, ) => ({ type: FETCH_PARTS_ERROR, error })
const startFetchPartsAsync = buildAsyncAction(
  FETCH_PARTS,
  FETCH_PARTS_START,
  [FETCH_PARTS_SUCCESS, FETCH_PARTS_ERROR]
)

const postParts = (partName, partData, partSettingName) => ({ type: POST_PARTS, partName, partData, partSettingName })
const postPartsStart = () => ({ type: POST_PARTS_START })
const postPartsSuccess = () => ({ type: POST_PARTS_SUCCESS })
const postPartsError = (error) => ({ type: POST_PARTS_ERROR, error })

export {
  updateEditValue,
  updateLastUpdated,
  updateLoadingPart,
  updateParts,
  updatePartData,
  fetchParts,
  fetchPartsStart,
  fetchPartsSuccess,
  fetchPartsError,
  startFetchPartsAsync,
  postParts,
  postPartsStart,
  postPartsSuccess,
  postPartsError,
}
